import { render, staticRenderFns } from "./signDetails.vue?vue&type=template&id=1f843162&scoped=true&"
import script from "./signDetails.vue?vue&type=script&lang=js&"
export * from "./signDetails.vue?vue&type=script&lang=js&"
import style0 from "./signDetails.vue?vue&type=style&index=0&id=1f843162&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f843162",
  null
  
)

export default component.exports